// Generated from src/img/svg/edit.svg

export const Edit = (props) => {
  return (
    <svg height="16.254" viewBox="0 0 16.254 16.254" width="16.254" {...props}>
      <path
        d="M4.5 17.364v3.386h3.386l9.986-9.986-3.386-3.385Zm15.99-9.218a.9.9 0 0 0 0-1.273L18.377 4.76a.9.9 0 0 0-1.273 0l-1.652 1.653L18.837 9.8z"
        style={{ fill: "#a2a2a2" }}
        transform="translate(-4.5 -4.496)"
      />
    </svg>
  );
};
